import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const slides = [
  'https://public.readdy.ai/ai/img_res/555a94c3e514b4bcd7d1f9bf1968df7e.jpg',
  'https://readdy.ai/api/search-image?query=professional%20plumbing%20team%20three%20workers%20matching%20navy%20blue%20uniforms%20modern%20bathroom%20renovation%20copper%20pipes%20chrome%20fittings%20team%20cooperation%20bright%20clean%20environment%20high%20quality%20commercial%20photography%20Turkey&width=1440&height=900&seq=h2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=complete%20modern%20bathroom%20renovation%20new%20pipes%20chrome%20fixtures%20clean%20white%20ceramic%20tiles%20professional%20plumbing%20workmanship%20bright%20natural%20light%20real%20estate%20photography%20Turkey&width=1440&height=900&seq=h3&orientation=landscape',
];

export default function HeroSection() {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setCurrent((p) => (p + 1) % slides.length), 5000);
    return () => clearInterval(timer);
  }, []);

  const stats = [
    { value: '15+', label: t('hero.stat1.label') },
    { value: '3', label: t('hero.stat2.label') },
    { value: '500+', label: t('hero.stat3.label') },
    { value: '7/24', label: t('hero.stat4.label') },
  ];

  return (
    <section className="relative overflow-hidden" style={{ minHeight: '100svh' }}>
      {/* Background slides */}
      {slides.map((img, idx) => (
        <div
          key={idx}
          className={`absolute inset-0 transition-opacity duration-1000 ${idx === current ? 'opacity-100' : 'opacity-0'}`}
        >
          <img src={img} alt="Vanpolat Tesisat" className="w-full h-full object-cover object-center" />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/75" />

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center items-center text-center px-4 py-32 min-h-screen">
        {/* Badge */}
        <span className="inline-flex items-center gap-1.5 bg-blue-600 text-white text-xs font-semibold px-3 py-1.5 rounded-full mb-5">
          <i className="ri-map-pin-fill text-xs"></i>
          {t('hero.badge')}
        </span>

        {/* Title */}
        <h1 className="text-3xl sm:text-5xl md:text-6xl font-extrabold text-white mb-4 max-w-3xl leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
          Van Polat Tesisat - Profesyonel Tesisat Hizmetleri
        </h1>

        {/* Subtitle */}
        <p className="text-white/85 text-base sm:text-xl mb-8 max-w-lg leading-relaxed">
          Van Polat Tesisat olarak Van ve çevresinde profesyonel tesisat hizmetleri sunuyoruz. Su kaçağı tespiti, tıkanıklık açma, kombi servisi ve petek temizleme işlemlerini son teknoloji cihazlarla hızlı ve güvenilir şekilde yapıyoruz. Uygun fiyat ve garantili hizmet için bizimle iletişime geçin. 7/24 hizmet vermekteyiz.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 w-full max-w-sm sm:max-w-none sm:w-auto">
          <a
            href="tel:+905076074165"
            className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-bold text-base px-7 py-4 rounded-xl transition-all cursor-pointer whitespace-nowrap"
            style={{ minHeight: 56 }}
          >
            <i className="ri-phone-fill text-xl"></i>
            {t('nav.call')} · 0507 607 4165
          </a>
          <a
            href="https://wa.me/905076074165?text=Merhaba%2C%20tesisat%20konusunda%20yard%C4%B1m%20istiyorum."
            target="_blank"
            rel="nofollow noreferrer"
            className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 active:bg-green-700 text-white font-bold text-base px-7 py-4 rounded-xl transition-all cursor-pointer whitespace-nowrap"
            style={{ minHeight: 56 }}
          >
            <i className="ri-whatsapp-line text-xl"></i>
            WhatsApp ile Yaz
          </a>
          <Link
            to="/randevu"
            className="flex items-center justify-center gap-2 bg-white/15 hover:bg-white/25 active:bg-white/30 border border-white/40 hover:border-white/70 text-white font-bold text-base px-7 py-4 rounded-xl transition-all cursor-pointer whitespace-nowrap backdrop-blur-sm"
            style={{ minHeight: 56 }}
          >
            <i className="ri-calendar-check-line text-xl"></i>
            Randevu Al
          </Link>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-4 gap-3 mt-10 w-full max-w-lg">
          {stats.map((s) => (
            <div key={s.label} className="bg-white/15 backdrop-blur-sm rounded-xl py-3 px-2 text-center border border-white/20">
              <p className="text-xl sm:text-2xl font-extrabold text-white leading-none mb-1" style={{ fontFamily: 'Poppins, sans-serif' }}>{s.value}</p>
              <p className="text-white/70 text-xs leading-tight">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Dots */}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`rounded-full transition-all cursor-pointer ${i === current ? 'bg-white w-6 h-2' : 'bg-white/40 w-2 h-2'}`}
            aria-label={`Slayt ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
